import { PIN_SPEC } from '~/client/src/shared/map/markerGeometry'

import type { IMapAnchoredCardOptions } from './MapAnchoredCardController'

// One placement for both map-first surfaces (type picker, Composer), so the hand-off
// between them doesn't jump.
export const WORKFLOW_PIN_CARD_ANCHOR: IMapAnchoredCardOptions['anchor'] = {
  gapPx: 30,
  // The Move badge's right edge (DomMovablePin). The picker's pin has no badge but
  // keeps it, so the card doesn't shift on hand-off.
  rightExtentPx: 19,
  // DomPin's tip sits on the coordinate, so the head centre is the rest of its box.
  risePx: PIN_SPEC.boxPx * (1 - PIN_SPEC.headCenterRatio),
}

export const WORKFLOW_PIN_CARD_SURFACE_CLASS =
  'tw:rounded-lg tw:border tw:border-border tw:bg-popover tw:shadow-md'

// Levels the card's first input (Composer title, picker search) with the pin head; null
// while the input is absent (pill, or the stale-DOM window mid-reproject) so the
// controller reuses cached leveling.
export function measureFirstInputCenter(wrapper: HTMLElement): number | null {
  const input = wrapper.querySelector('input')
  if (!input) {
    return null
  }
  const wrapperRect = wrapper.getBoundingClientRect()
  const inputRect = input.getBoundingClientRect()
  return inputRect.top + inputRect.height / 2 - wrapperRect.top
}
